import React from "react";
import ReactDOM from "react-dom/client";
import { StoreProvider } from "./store/store-reducer";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>
);

reportWebVitals();
